import { useEffect, useState } from "react";
import { BookOpen } from "lucide-react";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";
import { eur } from "@/lib/format";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function PartPicker({ value, onText, onPick, testid }) {
  const [open, setOpen] = useState(false);
  const [hits, setHits] = useState([]);
  useEffect(() => {
    if (!open || (value || "").trim().length < 2) { setHits([]); return undefined; }
    const t = setTimeout(() => api.get("/parts", { params: { q: value.trim() } }).then((r) => setHits(r.data)).catch(() => {}), 250);
    return () => clearTimeout(t);
  }, [value, open]);
  return (
    <div className="relative">
      <Input placeholder="Cerca nel catalogo o scrivi" value={value} onFocus={() => setOpen(true)} onBlur={() => setTimeout(() => setOpen(false), 200)}
        onChange={(e) => onText(e.target.value)} data-testid={testid} />
      {open && hits.length > 0 && (
        <div className="absolute z-30 mt-1 max-h-64 w-[min(22rem,85vw)] overflow-y-auto rounded-xl border bg-white shadow-lg" data-testid={`${testid}-results`}>
          {hits.map((p) => (
            <button key={p.id} type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => { onPick(p); setOpen(false); }}
              className="flex w-full items-center gap-2 border-b px-3 py-2 text-left text-sm hover:bg-[#f2f7ec]" data-testid={`${testid}-hit-${p.code}`}>
              {p.photo_url ? <img src={`${BACKEND}${p.photo_url}`} alt="" className="h-9 w-9 rounded-lg object-cover" /> : <BookOpen className="h-4 w-4 text-slate-400" />}
              <span className="min-w-0 flex-1"><span className="block truncate font-medium">{p.description}</span><span className="font-mono text-[11px] text-slate-500">{p.code}</span></span>
              <span className="font-mono text-xs">{eur(p.sale_price)}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
